import {useCallback, useEffect, useState} from 'react'
import {
  CampType,
  MessageReportParams,
  MessageReportResponse,
} from '../../../../../services/cellcast.v2.types'
import moment from 'moment-timezone'
import {useLazyQuickMessageReportQuery} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {UseLazyQuery} from '@reduxjs/toolkit/dist/query/react/buildHooks'
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryDefinition,
} from '@reduxjs/toolkit/dist/query'

export function useMessageReport(
  campType: CampType,
  loader: UseLazyQuery<
    QueryDefinition<
      MessageReportParams,
      BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
      never,
      MessageReportResponse,
      'cellcast_api_v2'
    >
  >,
  groupBy = ''
) {
  // configure date range
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [params, setParams] = useState<MessageReportParams>({
    campType: campType,
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    page: 1,
    limit: 10,
    groupBy,
  })
  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, fetchData] = loader()

  useEffect(() => {
    fetch(params)
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  return {
    params,
    setParams,

    fetchData,
    setTriggerFetch,
  }
}
